import React from 'react';

const CreditCardFeeDisclaimer = ({ creditCardFeePrice, creditCardFeeQueryInProgress, creditCardFeeQueryError }) => {
    return (
        <>
            {creditCardFeeQueryError ?
                <span style={{'font-weight': 'bold'}}>Error calculating credit card fee</span> :
            creditCardFeeQueryInProgress ?
                <span style={{'font-weight': 'bold'}}>Calculating credit card fee...</span> :
            creditCardFeePrice ?
                <span style={{'font-weight': 'bold'}}>A credit card fee of ${creditCardFeePrice} will be applied across the invoice(s)</span> :
                null
            }
        </>
    );
};

export default CreditCardFeeDisclaimer;
